<app-inventory-create />
<app-inventory-mass-update-create />

<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
  <div>
      <div class="row mt-3">
          <div class="col-9">
              <div class="mb-3 d-flex justify-content-between">
                  <h2 class="title-list">List of SIMS</h2>
              </div>
          </div>

          <div class="col-3 text-end">
              <div class="d-flex flex-row-reverse bd-highlight">

                  <div style="margin-left: 1em">
                      <button appTooltip="Show Archived Devices" class="btn btn-secondary" (click)="toggleArhivedMode()">
                          <i class="bi bi-archive"></i>
                      </button>
                  </div>

                  <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                      <a class="btn btn-primary" [routerLink]="['/inventory/transfers']">
                          <i class="bi bi-arrow-right-circle" style="margin-right: 5px;"></i>
                          Device Transfers
                      </a>

                      <div class="btn-group" role="group">
                          <button type="button" class="btn btn-outline-success dropdown-toggle" data-bs-toggle="dropdown"
                                  aria-expanded="false">
                          </button>
                          <ul class="dropdown-menu">
                              <li>
                                  <a class="dropdown-item" style="white-space: nowrap;" [routerLink]="['/inventory/revert-transfer']">
                                      <i class="bi bi-arrow-counterclockwise" style="margin-right: 5px;"></i>
                                      Revert transfer
                                  </a>
                              </li>
                              <!-- <li><a class="dropdown-item" href="#">Dropdown link</a></li> -->
                          </ul>
                      </div>
                  </div>


              </div>
          </div>
      </div>

          <app-table-control [data]="sims" [columns]="columns" [pageSize]="5" [showCheckboxes]="true"
                             (selectedItemsChange)="onSelectionChange($event)" (actionClick)="onAction($event)"
                             [clearSelection]="shouldClearSelection" [pageSize]="5" [actionButtons]="actionButtons" [showActions]="true"
                             (filteredItemsChange)="onFilteredItemsChange($event)" [showCheckboxes]="false" [sheetName]="'Inventory'">
          </app-table-control>



      </div>
</div>



<!-- Modal -->
<div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                Device {{isArhivedMode ? 'Restore' : 'Archive'}}
            </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updateSimStatus(false)"></button>
        </div>
        <div class="modal-body">
            Are you sure you want to {{isArhivedMode ? 'Restore' : 'Archive'}} this device?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateSimStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateSimStatus(true)">
              Yes, {{isArhivedMode ? 'Restore' : 'Archive'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Fin Modal Transfer Sims -->
<!-- Modal Logs -->
<app-device-api-logs [device]="selectedSim" [showModal]="showDeviceApiLogsModal"
  (onDismiss)="onDismiss($event)"></app-device-api-logs>